var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout layout--landing",attrs:{"id":"app"}},[_c('announcements-bar'),_c('landing-header-bar'),_c('div',{attrs:{"id":"content"}},[_c('nuxt')],1),_c('landing-footer-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }